<template>
    <div class="wrap">
        <dyList :list="list"></dyList>
        <div class="page-box" v-show="total">
            <el-pagination :pager-count="5" :page-size="20" @current-change="changePage" background layout="prev, pager, next" :total="total"></el-pagination>
        </div>
    </div>
</template>
<script>
    import dyList from "@components/common/dy-list";
    import {
        mapGetters,
        mapMutations
    } from "vuex";
    export default {
        components: {
            dyList,
        },
        data() {
            return {
                list: [],
                total: 0,
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
        },
        mounted() {
            // 在组件被挂载之后调用。
            this.getData(1);
        },
        methods: {
            changePage(s) {
                this.getData(s);
            },
            // 获取列表
            async getData(page) {
                // let $r = this.$route.query;
                // let u = "api/nihao/posts";
                // if ($r && $r.type) {
                //   switch ($r.type) {
                //     case "sc":
                //       u = "api/nihao/collection";
                //       break;
                //     case "buy":
                //       u = "api/nihao/order";
                //       break;
                //   }
                // }
                let myid = this.$y_getKey('userid');
                let $r = this.$route.query;
                let uid = $r.uuid || myid;
                let param = {
                    userid: uid,
                    user_id: myid,
                    type: 0,
                    longitude: this.$y_getKey('lon'),
                    latitude: this.$y_getKey('lat'),
                };
                param.page = page || 1;
                let {
                    list,
                    total
                } = await this.$y_list('api/dymanic/lists', [], param);
                this.list = list;
                this.total = total;
            },
        },
        computed: {
            ...mapGetters(["s_getUser", "s_getCity"]),
        },
        watch: {
            $route() {
                this.getData(1);
            },
            s_getUser() {
                this.getData(1);
            },
            s_getCity() {
                this.getData(1);
            },
        },
    };
</script>

<style lang="less" scoped>

</style>